import React from 'react';
import UserLayout from '../components/UserLayout';
import PackageShipment from '../components/PackageShipment';

const PackageShipmentPage = () => {
    return (
        <UserLayout>
            <PackageShipment />
        </UserLayout>
    );
};

export default PackageShipmentPage;
